import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, ButtonOwnProps } from '@mui/material';
import { useAtomValue } from 'jotai';
import { Payment_Method_Enum } from '@kheops/graphql';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentDownloadFile } from '../../hooks/useDownloadFile';
import useOrderInvoiceType from '../../hooks/useOrderInvoiceType';
import { documentDownloadUrlsAtom, orderInvoiceAtom } from '../state/state';

interface OrderInvoiceButtonProps {
  orderFriendlyId: string;
  hasCommission: boolean;
  hasInvoiceGeneration: boolean;
  paymentMethod: Payment_Method_Enum;
  color?: ButtonOwnProps['color'];
}

export default function OrderInvoiceButton({ orderFriendlyId, hasCommission, hasInvoiceGeneration, paymentMethod, color }: OrderInvoiceButtonProps): React.JSX.Element {
  const { t } = useTranslation(['order']);
  const invoiceType = useOrderInvoiceType(hasCommission, hasInvoiceGeneration, paymentMethod);
  const documentDownloadUrls = useAtomValue(documentDownloadUrlsAtom);
  const invoice = useAtomValue(orderInvoiceAtom);
  const invoiceReference = invoice?.revised_reference || invoice?.reference;

  const downloadUrl = useMemo(
    () => documentDownloadUrls.get(invoiceType),
    [invoiceType, documentDownloadUrls],
  );

  const handleButtonClick = useDocumentDownloadFile({
    documentType: invoiceType,
    downloadUrl: downloadUrl!,
    orderId: orderFriendlyId,
    documentReference: invoiceReference!,
  });

  return (
    <Button
      variant="outlined"
      onClick={handleButtonClick}
      loading={!downloadUrl}
      startIcon={<FileDownloadOutlinedIcon />}
      color={color}
      sx={{ flex: 'auto' }}
    >
      {t('order:see_invoice')}
    </Button>
  );
}
